<template>
  <div class="billing-overview">
    <page-header title="Billing" icon="file-alt">
      <div slot="sub-title">
        Organization billing overview
      </div>
    </page-header>
    <el-row :gutter="20" class="body-padding mobile-padding">
      <el-col :span="24" class="space-bottom">
        <billing-filter @date="getOrganizations" @filter-deficit="filter.deficit = $event" @filter-profit="filter.profit = $event" />
      </el-col>
      <el-col :span="24" v-loading="loading">
        <el-table
          :show-header="false"
          v-if="!loading"
          :data="filteredOrganizations">
          <el-table-column type="expand">
            <template slot-scope="props">
              <invoice-controls
                v-if="!thisMonth"
                :data="props.row"
                :selectedMonth="selectedMonth"
                :from="range.from"
                :to="range.to" />
              <div class="values fake-header">
                <p>Description</p>
                <p>Amount</p>
                <p>Rate</p>
                <p>Total</p>
              </div>
              <div v-for="(transaction, index) in props.row.sortedTransactions" :key="index">
                <div class="values">
                  <p class="can-expand" @click="transaction.expanded = !transaction.expanded"><span><i :class="{ 'el-icon-arrow-down': transaction.expanded, 'el-icon-arrow-right': !transaction.expanded }" /> Fee of income</span></p>
                  <p><span>{{ transaction.total.toFixed(2) }} {{ props.row.organization.currency.name }}</span></p>
                  <p><span>{{ transaction.rate }} %</span></p>
                  <p class="total"><span :class="[totalDifferenceClass(calcTotal(transaction.rate, transaction.total, props.row.model.monthlyFee))]">{{ calcTotal(transaction.rate, transaction.total, props.row.model.monthlyFee) }} {{ props.row.organization.currency.name }}</span></p>
                </div>
                <div class="expander" v-if="transaction.expanded">
                  <div class="values no-border" v-for="t in transaction.transactions" :key="t.id">
                    <p>{{ t.user.name }} - {{ t.name }}<br />{{ t.description }}{{ t.station ? ' @ ' + t.station.name : '' }}<br />{{ t.createdAt | dateTime }}</p>
                    <p>{{ t.amount }} {{ t.currency }}</p>
                    <p>{{ t.rate }} %</p>
                    <p>{{ calcTotal(t.rate, t.amount) }} {{ t.currency }}</p>
                  </div>
                </div>
              </div>
              <div class="values">
                <p><span>Total income</span></p>
                <p>-</p>
                <p>-</p>
                <p class="total"><span>{{ getTotalIncome(props.row.transactions) }} {{ props.row.organization.currency.name }}</span></p>
              </div>
              <div class="values more-border">
                <p><span>Subscription</span></p>
                <p>-</p>
                <p>-</p>
                <p class="total"><span class="out">- {{ props.row.model.monthlyFee.toFixed(2) }} {{ props.row.organization.currency.name }}</span></p>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Name" prop="organization.name" />
          <el-table-column label="Difference">
            <template slot-scope="scope">
              <div class="difference" :class="[totalDifferenceClass(calcRowTotal(scope.row))]">
                <el-tag size="small" v-if="scope.row.hasInvoice" style="margin-right: 10px;">Invoice sent</el-tag>
                {{ calcRowTotal(scope.row) }} {{ scope.row.organization.currency.name }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import BillingFilter from './Filter'
import InvoiceControls from './InvoiceControls'

export default {
  name: 'BillingOverview',
  components: { BillingFilter, InvoiceControls },
  data () {
    return {
      thisMonth: true,
      range: {
        from: null,
        to: null
      },
      selectedMonth: 0,
      filter: {
        profit: true,
        deficit: true
      },
      loading: true,
      organizations: []
    }
  },
  computed: {
    filteredOrganizations () {
      return this.organizations.filter(item => {
        if (this.filter.profit && (this.calcRowTotal(item) > 0)) {
          return item
        }
        if (this.filter.deficit && (this.calcRowTotal(item) <= 0)) {
          return item
        }
      })
    }
  },
  methods: {
    test () {
      console.log('h')
    },
    formatCreatedAt (model, index) {
      var start = new Date(model.createdAt).toDateString().split(' ')
      var end = new Date(model.endedAt).toDateString().split(' ')

      start = start.slice(1).join(' ')

      if (model.current) {
        return start + ' - Current'
      } else {
        return start + ' - ' + model.endedAt
      }
    },
    getTotalIncome (transactions) {
      let total = 0
      transactions.forEach(t => {
        total += t.amount
      })

      return total.toFixed(2)
    },
    calcCut (model) {
      return (model.total * (model.rate / 100)).toFixed(2)
    },
    calcRowTotal (organization) {
      let total = organization.model.monthlyFee - organization.total
      for (let key in organization.sortedTransactions) {
        const t = organization.sortedTransactions[key]
        total += t.cut
      }
      return (-1 * total).toFixed(2)
    },
    calcTotal (fee, total) {
      return (-1 * ((total * (fee / 100)))).toFixed(2)
    },
    totalDifferenceClass (val) {
      return val < 0 ? 'out' : ''
    },
    sortTransactions (organization) {
      let transactions = {}
      organization.transactions.forEach((transaction) => {
        if (transactions.hasOwnProperty(transaction.rate.toString())) {
          transactions[transaction.rate.toString()].total += transaction.amount
          transactions[transaction.rate.toString()].cut += transaction.amount * (transaction.rate / 100)
          transactions[transaction.rate.toString()].transactions.push(transaction)
        } else {
          transactions[transaction.rate.toString()] = {
            expanded: false,
            transactions: [transaction],
            total: transaction.amount,
            rate: transaction.rate,
            cut: transaction.amount * (transaction.rate / 100)
          }
        }
      })
      return transactions
    },
    async getOrganizations (range) {
      this.loading = true
      const date = new Date()
      let start = new Date(date.getFullYear(), date.getMonth(), 1)
      let end = new Date(date.getFullYear(), date.getMonth() + 1, 0)

      if (range) {
        start = new Date(range[0].getFullYear(), range[0].getMonth(), range[0].getDate())
        end = new Date(range[1].getFullYear(), range[1].getMonth(), range[1].getDate())
      }

      const startString = start.getFullYear() + '-' + (start.getMonth() + 1) + '-' + start.getDate()
      const endString = end.getFullYear() + '-' + (end.getMonth() + 1) + '-' + end.getDate()

      this.selectedMonth = start.getMonth()

      if (start.getMonth() !== new Date().getMonth()) {
        this.thisMonth = false
      } else {
        this.thisMonth = true
      }

      this.range.from = start
      this.range.to = end

      let query = '?start=' + startString + '&end=' + endString
      const response = await this.$http.get(this.$api.organizations.billings + query)
      response.data.forEach(o => {
        o.sortedTransactions = this.sortTransactions(o)
      })
      this.organizations = response.data
      this.loading = false
    }
  },
  created () {
    this.getOrganizations()
  }
}
</script>

<style lang="scss" scoped>
  .expander {
    width: 100%;
    padding: 10px 0px 30px 0px;
  }

  .invoice-button {
    margin-left: 10px;
  }

  .values {
    padding: 0px 20px;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 0 auto;
    border-top: 1px solid $bg;
    height: 60px;

    &.more-border {
      border-bottom: 2px solid $bg;
    }

    &.no-border {
      height: auto;
      border: none;

      p {
        box-sizing: border-box;
        &:first-child {
          padding-left: 30px;
        }
      }
    }
  }

  .fake-header {
    border-top: none;
    p {
      font-size: 12px;
    }
  }

  p {
    width: 25%;
    font-size: 14px;
    color: $text-light;
    display: flex;
    justify-content: flex-end;

    &:first-child {
      justify-content: flex-start;
    }

    &.can-expand {
      cursor: pointer;
    }

    span {
      color: #909399;

      i {
        color: #909399;
        font-size: 12px;
        margin-right: 10px;
      }
    }

    &.total {
      flex-direction: row;
      margin-bottom: 15px;
      font-size: 14px;
      font-weight: 600;
      color: $text-light;

      span {
        margin-top: 0px;
      }
    }
  }

  .difference {
    width: 100%;
    text-align: right;
    font-weight: 600;
  }

  .out {
    color: $red !important;
  }

  .in {
    color: $green !important;
  }

  .space-bottom {
    margin-bottom: 50px;
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/billing-overview/BillingOverview.vue